import { defineSetting } from '../settingsRegistry';

declare module '../settingsRegistry' {
  interface Settings {
    /**
     * Blood on hits (C0-VFX, render/ink/samples.ts `drawBlood`): a sword cut bleeds. Off: a white and
     * ink impact flash with a small ink burst instead, so a hit still reads.
     */
    blood: boolean;
  }
}

defineSetting({
  key: 'blood',
  default: true,
  order: 45,
  menu: { group: 'visual', label: 'เลือด' },
});
